import React from 'react';
import { Feather, MaterialCommunityIcons } from '@expo/vector-icons';
import { PaprikaEntry } from '../../../styles/theme';
import type { MealEntryType } from '../../../redux/mealEntry';

export interface EntryMeta {
  /** Rendered with t(): the kicker on an entry card. */
  labelKey: string;
  iconLib: 'feather' | 'mci';
  icon: string;
  tint: string;
  color: string;
}

export const ENTRY_META: Record<MealEntryType, EntryMeta> = {
  dining:   { labelKey: 'entry.dining',    iconLib: 'mci',     icon: 'silverware-fork-knife', ...PaprikaEntry.dining },
  leftover: { labelKey: 'entry.leftovers', iconLib: 'mci',     icon: 'recycle',               ...PaprikaEntry.leftover },
  // « Repas simple » — a meal that is not a recipe (a tuna sandwich), not a
  // memo, so a bowl rather than the pencil it used to wear.
  note:     { labelKey: 'entry.note',      iconLib: 'mci',     icon: 'bowl-mix-outline',      ...PaprikaEntry.note },
  skip:     { labelKey: 'entry.nothing',   iconLib: 'feather', icon: 'slash',                 ...PaprikaEntry.skip },
};

// Shared icon renderer so every surface draws entry icons identically.
export function EntryIcon({ type, size, color }: { type: MealEntryType; size: number; color?: string }) {
  const m = ENTRY_META[type];
  const c = color ?? m.color;
  return m.iconLib === 'mci'
    ? <MaterialCommunityIcons name={m.icon as any} size={size} color={c} />
    : <Feather name={m.icon as any} size={size} color={c} />;
}
